var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.4C12.6636 2.4 13.2 2.93644 13.2 3.6V7.19401C13.2 7.39479 13.2416 7.59036 13.3466 7.76863L15.8735 12.1814C15.9785 12.3596 16.02 12.5552 16.02 12.756V21.15C16.02 21.8136 15.4836 22.35 14.82 22.35H9.18C8.51644 22.35 7.98 21.8136 7.98 21.15V12.756C7.98 12.5552 8.02155 12.3596 8.12655 12.1814L10.6534 7.76863C10.7584 7.59036 10.8 7.39479 10.8 7.19401V3.6C10.8 2.93644 11.3364 2.4 12 2.4Z",
    stroke: "#141414",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.02 14.55C16.02 13.8864 15.4836 13.35 14.82 13.35H9.18C8.51644 13.35 7.98 13.8864 7.98 14.55V17.55C7.98 18.2136 8.51644 18.75 9.18 18.75H14.82C15.4836 18.75 16.02 18.2136 16.02 17.55V14.55Z",
    stroke: "#141414",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottle);
export default __webpack_public_path__ + "static/media/bottle.41a26f54f8fedb907f68cff22617e0dc.svg";
export { ForwardRef as ReactComponent };